import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

export class ReviewOrderButton extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    showModal: PropTypes.func.isRequired
  };

  render () {
    return <Translate
      className='registered-orders-edit hide-mobile'
      onClick={this.props.showModal}
      content='BUTTON_REVIEW_AND_CREATE_INVOICE'
    />;
  }
}

export default ReviewOrderButton;



/** WEBPACK FOOTER **
 ** ./src/components/registered-orders/review-order-button.js
 **/